import { FC } from 'react';
import Panel, { PanelProps } from '../../Panel';
import CreditPlanFailureSidePanelContent, {
  CreditPlanFailureSidePanelContentProps
} from './CreditPlanFailureSidePanelContent';
import PanelContentWithErrorBoundary from '@/components/blocks/ErrorFallback/PanelContentWithErrorBoundary';

type CreditPlanFailureSidePanelProps = Omit<CreditPlanFailureSidePanelContentProps, 'closePanel'> &
  Omit<PanelProps, 'size' | 'children'>;

const CreditPlanFailureSidePanel: FC<CreditPlanFailureSidePanelProps> = props => {
  return (
    <Panel
      {...{
        ...props,
        size: 'medium'
      }}
    >
      <PanelContentWithErrorBoundary>
        <CreditPlanFailureSidePanelContent
          {...props}
          renderWithPanelContent={true}
          togglePanel={props.onOpenChange}
        />
      </PanelContentWithErrorBoundary>
    </Panel>
  );
};

export default CreditPlanFailureSidePanel;
